// extracted by mini-css-extract-plugin
export default {"header":"ProjectHeader_header__9Bfl3","left":"ProjectHeader_left__MaOZV","back":"ProjectHeader_back__Jw1dx","actions":"ProjectHeader_actions__cUsFb"};